import React, { useState } from "react";
import { Box, Typography, Stack, Collapse, Paper } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import { ParkingTypeSelector } from "./ParkingTypeSelector";

export function UnitTypeCard({ unitType, parkingTypes, configs, onConfigChange }) {
  const [open, setOpen] = useState(false);

// In UnitTypeCard toggleParking function:
const toggleParking = (ptId) => {
  const exists = configs.some((c) => c.parkingTypeId === ptId);
  if (exists) {
    onConfigChange(configs.filter((c) => c.parkingTypeId !== ptId));
  } else {
    // ✅ INITIAL: Included = true → isUpgrade = false
    onConfigChange([
      ...configs,
      { 
        parkingTypeId: ptId, 
        isIncluded: true,      // UI state
        isUpgrade: false,      // DB field (false = Included)
        isUpgradeEligible: false 
      },
    ]);
  }
};

// ✅ updateConfig also needs to map to DB fields
const updateConfig = (ptId, updates) => {
  onConfigChange(
    configs.map((c) => {
      if (c.parkingTypeId === ptId) {
        return {
          ...c,
          isIncluded: updates.isIncluded !== undefined ? updates.isIncluded : c.isIncluded,
          isUpgrade: updates.isIncluded !== undefined ? !updates.isIncluded : c.isUpgrade, // Map UI → DB
          isUpgradeEligible: updates.isUpgradeEligible ?? c.isUpgradeEligible,
        };
      }
      return c;
    })
  );
};



  return (
    <Paper variant="outlined" sx={{ borderRadius: 2 }}>
      <Box px={3} py={2.2} onClick={() => setOpen(!open)} sx={{ cursor: "pointer" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              width={38}
              height={38}
              borderRadius={2}
              bgcolor="#fafbff"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <HomeIcon fontSize="small" />
            </Box>
            <Typography sx={{ fontSize: 15, fontWeight: 800 }}>
              {unitType.name}
            </Typography>
           
          </Stack>

          <ExpandMoreIcon
            sx={{
              transform: open ? "rotate(180deg)" : "rotate(0)",
              transition: "0.2s",
            }}
          />
        </Stack>
      </Box>

      <Collapse in={open}>
        <Box px={3} pb={3}>
          <Typography sx={{ fontSize: 12, fontWeight: 800 }} color="text.secondary" mb={1.5}>
            AVAILABLE PARKING TYPES
          </Typography>

        

          <Stack spacing={1.2}>
            {parkingTypes.map((pt) => {
              const cfg = configs.find((c) => c.parkingTypeId === pt.id);
              return (
                <ParkingTypeSelector
                  key={pt.id}
                  parkingType={pt}
                  isSelected={!!cfg}
                  isIncluded={cfg?.isIncluded ?? true}
                  isUpgradeEligible={cfg?.isUpgradeEligible ?? false}
                  onToggle={() => toggleParking(pt.id)}
                  onIncludedChange={(v) => updateConfig(pt.id, { isIncluded: v })}
                  onUpgradeChange={(v) => updateConfig(pt.id, { isUpgradeEligible: v })}
                />
              );
            })}
          </Stack>
        </Box>
      </Collapse>
    </Paper>
  );
}
